import { render, staticRenderFns } from "./Vendasbairros.vue?vue&type=template&id=f2593fdc&"
import script from "./Vendasbairros.vue?vue&type=script&lang=js&"
export * from "./Vendasbairros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports